import React from "react";
import ReactDOM from "react-dom/client";
import "primeflex/primeflex.css";
import "./styles/Index.css";
import './styles/Layout.css';
import './styles/App.css';
import './styles/Header.css';
import './styles/Page.css';
import './styles/Sidebar.css';
import './styles/ThemeSwitcher.css';

import App from "./App";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { RequireAccess, RequireAuth } from "./guards";
import { ThemeProvider } from "./contexts/ThemeContext";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./pages/home";
import Login from "./pages/login";
import ResetarSenha from "./pages/resetar-senha";
import Usuarios from "./pages/usuarios";
import Ordem from "./pages/ordem";
import Ordens from "./pages/ordens";
import Agendamento from "./pages/Agendamento";
import store from "./store";
import Equipes from "./pages/equipes";
import AgendaPage from "./pages/AgendaPage";
import Procuracao from "./pages/procuracao";
import Relatorio from "./pages/relatorio";
import RelatorioAtendimentoEquipe from "./pages/relatorioAtendimentoEquipe";

// Configurar o store globalmente
window.store = store;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <ThemeProvider>
        <Provider store={store}>
            <Router>
                {AppWGSol()}
            </Router>
        </Provider>
    </ThemeProvider>
);


function AppWGSol() {
    
    return (
        <App>
            <Routes>
                
                <Route
                    path="/"
                    element={
                        <RequireAuth>
                            <Home/>
                        </RequireAuth>
                    }
                />

                <Route
                    path="/usuarios"
                    element={
                        <RequireAccess roles={["ADMINISTRADOR"]}>
                            <Usuarios/>
                        </RequireAccess>
                    }
                />

                <Route
                    path="/equipes"
                    element={
                        <RequireAccess roles={["ADMINISTRADOR", "AUXILIAR_ADMINISTRATIVO"]}>
                            <Equipes/>
                        </RequireAccess>
                    }
                />

                <Route
                    path="/ordens"
                    element={
                        <RequireAccess roles={['ADMINISTRADOR', 'AUXILIAR_ADMINISTRATIVO', 'FINANCEIRO', 'POS_VENDA', 'ORCAMENTISTA', 'VENDEDOR']}>
                            <Ordens/>
                        </RequireAccess>
                    }
                />

                <Route
                    path="/agenda"
                    element={
                        <RequireAuth>
                            <AgendaPage/>
                        </RequireAuth>
                    }
                />

                <Route
                    path="/ordem/nova"
                    element={
                        <RequireAccess roles={['ADMINISTRADOR', 'VENDEDOR']}>
                            <Ordem/>
                        </RequireAccess>
                    }
                />

                <Route
                    path="/ordem/:id"
                    element={
                        <RequireAccess roles={['ADMINISTRADOR', 'AUXILIAR_ADMINISTRATIVO', 'FINANCEIRO', 'POS_VENDA', 'ORCAMENTISTA', 'VENDEDOR']}>
                            <Ordem/>
                        </RequireAccess>
                    }
                />

                <Route
                    path="/procuracao"
                    element={
                        <RequireAccess roles={["ADMINISTRADOR", "VENDEDOR", "AUXILIAR_ADMINISTRATIVO"]}>
                            <Procuracao/>
                        </RequireAccess>
                    }
                />

                <Route
                    path="/agendamento/:externalAccessUuid"
                    element={
                            <Agendamento/>
                    }
                />

                <Route
                    path="/relatorios/acompanhamento"
                    element={
                        <RequireAccess roles={["ADMINISTRADOR"]}>
                            <Relatorio/>
                        </RequireAccess>
                    }
                />

                <Route
                    path="/relatorios/atendimento-equipe"
                    element={
                        <RequireAccess roles={["ADMINISTRADOR"]}>
                            <RelatorioAtendimentoEquipe/>
                        </RequireAccess>
                    }
                />
                
                <Route path="/entrar" element={<Login />} />
                <Route path="/recuperar-senha" element={<ResetarSenha />} />
            </Routes>
        </App>
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
